import { createCommonOrderSelectors } from '../lib/createCommonOrderSelectors';
export const checkoutCommonSelectors = createCommonOrderSelectors(state => state.order);
export const checkinCommonSelectors = createCommonOrderSelectors(state => state.order);
